import React from 'react';
import { Pie } from 'react-chartjs-2';
import { prepareCacheChartData } from './metricsHelpers';

const CacheTab = ({ currentMetrics }) => {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="text-lg font-semibold text-gray-700 mb-4">Cache Performance</h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div>
          <h4 className="text-sm font-medium text-gray-500 mb-2">Cache Hits</h4>
          <p className="text-xl font-bold text-green-600">
            {currentMetrics && currentMetrics.cache_hits != null
              ? currentMetrics.cache_hits.toLocaleString()
              : 'N/A'}
          </p>
        </div>

        <div>
          <h4 className="text-sm font-medium text-gray-500 mb-2">Cache Misses</h4>
          <p className="text-xl font-bold text-red-600">
            {currentMetrics && currentMetrics.cache_misses != null
              ? currentMetrics.cache_misses.toLocaleString()
              : 'N/A'}
          </p>
        </div>

        <div>
          <h4 className="text-sm font-medium text-gray-500 mb-2">Cache Hit Ratio</h4>
          <p className="text-xl font-bold text-blue-600">
            {currentMetrics && currentMetrics.cache_hit_ratio != null
              ? `${(currentMetrics.cache_hit_ratio * 100).toFixed(1)}%`
              : 'N/A'}
          </p>
        </div>
      </div>

      {currentMetrics && (
        <div className="flex justify-center">
          <div className="w-64">
            <Pie
              data={prepareCacheChartData(currentMetrics)}
              options={{
                responsive: true,
                plugins: {
                  legend: {
                    position: 'bottom'
                  }
                }
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CacheTab;
